/* eslint-disable no-nested-ternary */
import React, { useState, useEffect } from 'react'
import TrackAwait from 'AccountsIcons/time.svg'
import TrackAwaitDelayed from 'AccountsIcons/timeDelay.svg'
import TrackDone from 'AccountsIcons/tick.svg'
import TrackFail from 'AccountsIcons/cross.svg'
import TrackIdle from 'SVGPath/track-idle.svg'
import Down from 'SVGPath/down-chevron.svg'
import { arrDepFormatter, fireClevertapEvent } from 'AccountsUtils'
import { SlideModal } from '.'

const trackIcons = [
  <TrackAwait fill="#339902" />,
  <TrackDone fill="#339902" />,
  <TrackFail fill="#ff3b30" />
]

const statusClass = ['', 'active-tag', '']

// eslint-disable-next-line complexity
const RefundTrackerSteps = props => {
  const {
    active,
    status,
    msg,
    dueMsgs,
    commonMsg,
    tag,
    first,
    isPWA,
    last,
    type,
    bookingInfo,
    docs,
    indx,
    colorFlag
  } = props

  let activeClass = (active && status && statusClass[status]) || (status === null && 'c-grey-30')
  const [isCollapsed, toggleCollapse] = useState(true)
  const [openDocModal, setOpenDocModal] = useState(false)

  useEffect(() => {
    toggleCollapse(type === 'collapse')
  }, [])
  const toggler = () => {
    if (type === 'collapse') {
      toggleCollapse(!isCollapsed)
    }
  }

  const closeDocModal = e => {
    fireClevertapEvent('View_documents_needed_shown_pwa')
    setOpenDocModal(false)
    const ele = document.getElementsByClassName('zen-body')
    if (ele && ele[0]) {
      ele[0].classList.remove('overflow-hidden')
    }
  }

  const openDoc = e => {
    fireClevertapEvent('View_documents_needed_clicked_pwa')
    const ele = document.getElementsByClassName('zen-body')
    if (ele && ele[0]) {
      ele[0].classList.remove('overflow-hidden')
    }
    setOpenDocModal(true)
  }

  const paxDetail = pax => {
    return ` ${String.fromCharCode(183)} ${pax[0]} ${pax.length > 1 ? `+${pax.length - 1}` : ''}`
  }

  activeClass = activeClass || ''
  return (
    <React.Fragment>
      <If condition={openDocModal}>
        <SlideModal
          header="Documents required"
          open={openDocModal}
          onCloseClick={e => closeDocModal(e)}
          refundToggle={openDocModal}
        >
          <div className="p-4 bg-white">
            <ol>
              {docs &&
                docs.map((val, index) => {
                  return (
                    <li className="pt-2 pl-2 fs-13 c-neutral-500" id={index}>
                      {`${index + 1}. ${val}`}
                    </li>
                  )
                })}
            </ol>
          </div>
        </SlideModal>
      </If>
      <li className={`${isPWA ? '' : 'flex-1'} ${indx === 0 && 'pt-2'} px-4`}>
        <div
          className={`flex
      ${!isPWA ? 'flex-column py-4' : 'py-2'}
      ${!isPWA && first ? 'flex-start' : ''}
      ${!isPWA && last ? 'flex-end' : ''}
        ${!isPWA && !last && !first ? 'flex-center' : ''}`}
        >
          <div
            className={`${!isPWA ? 'flex' : ''}
      ${!isPWA && first ? 'flex-start' : ''}
      ${!isPWA && last ? 'flex-end' : ''}
      ${!last ? 'tracker-icon-mob' : ''}
      ${!isPWA ? '' : 'pr-2'}
      ${!isPWA && !last && !first ? ' flex-center' : ''}`}
          >
            <If condition={status === '0'}>
              <If condition={colorFlag && colorFlag.toLowerCase() === 'red'}>
                <TrackAwaitDelayed fill="#ff3c2b" />
                <Else />
                <TrackAwait fill="#339902" />
              </If>
            </If>
            <If condition={status && !(status === '0')}>
              {trackIcons[status]}
              <Else />
              <If condition={isPWA && !(status === '0')}>
                <TrackIdle />
              </If>
            </If>
          </div>
          <div className={`flex-1 ${!isPWA || last ? '' : 'pb-4 border-bottom-grey'}`}>
            <div className="flex flex-between flex-middle">
              <If condition={status === '0'}>
                <p
                  className={`${isPWA ? 'fs-15' : 'fs-caption-2 pt-1'}
          ${!isPWA && first ? 'ta-left' : ''}
      ${!isPWA && last ? 'ta-right' : ''}
      ${!isPWA && !last && !first ? ' ta-center' : ''} ${activeClass} ${status === '0' &&
                    (docs && docs.length === 0) &&
                    'mob-active-tag'} ${
      (status === '0' || status === '2') &&
                      (colorFlag && colorFlag.toLowerCase() === 'red') ?
        'c-error-500' :
        'green-success'
    } padding-top`}
                  onClick={toggler}
                >
                  {tag}
                </p>
                <Else />
                <p
                  className={`${isPWA ? 'fs-15' : 'fs-caption-2 pt-1'}
          ${!isPWA && first ? 'ta-left' : ''}
      ${!isPWA && last ? 'ta-right' : ''}
      ${!isPWA && !last && !first ? ' ta-center' : ''} ${activeClass} ${status === '0' &&
                    (docs && docs.length === 0) &&
                    'mob-active-tag'} ${(status === '0' || status === '2') &&
                    (colorFlag && colorFlag.toLowerCase() === 'red') &&
                    'c-error-500'} padding-top`}
                  onClick={toggler}
                >
                  {tag}
                </p>
              </If>
              {(msg || dueMsgs) && status === '1' && isCollapsed && (
                <Down
                  className={`arrow-min ${
                    type === 'collapse' && isCollapsed ? '' : 'collapsed-arrow'
                  }`}
                  onClick={toggler}
                />
              )}
            </div>
            <div
              className={`${!isPWA ? 'flex flex-between' : ''} ${
                type === 'collapse' && isCollapsed && status === '1' ? 'collapsed' : ''
              }`}
            >
              <If condition={dueMsgs && dueMsgs.length > 0}>
                {/* {msg.map(item => ( */}
                <If condition={status === '0'}>
                  <p
                    className={`${isPWA ? 'fs-13' : 'fs-caption-2'} ${
                      // eslint-disable-next-line no-nested-ternary
                      colorFlag && colorFlag.toLowerCase() === 'red' ?
                        'c-error-500' :
                        tag.toLowerCase() === 'refund generation' ?
                          'color-8a' :
                          'green-success'
                    } pt-2`}
                  >
                    {dueMsgs.join(' ')}
                  </p>
                  <Else />
                  <p
                    className={`${isPWA ? 'fs-13' : 'fs-caption-2'} ${
                      // eslint-disable-next-line no-nested-ternary
                      status ? 'color-8a' : 'c-grey-30'
                    } pt-2`}
                  >
                    {dueMsgs.join(' ')}
                  </p>
                </If>
              </If>
              <If condition={msg && msg.length > 0}>
                <p
                  className={`${isPWA ? 'fs-13' : 'fs-caption-2'} ${
                    status ? 'color-8a' : 'c-grey-30'
                  } pt-2`}
                >
                  {msg.join(' ')}
                </p>
              </If>
              <If condition={bookingInfo}>
                <p
                  className={`${isPWA ? 'fs-13' : 'fs-caption-2'} ${
                    status ? 'color-8a' : 'c-grey-30'
                  } pt-1`}
                >
                  {arrDepFormatter(
                    bookingInfo.departure,
                    bookingInfo.arrival,
                    bookingInfo.journeyType
                  )}
                  <span className="tt-capital">{paxDetail(bookingInfo.paxNames)}</span>
                </p>
              </If>
              <If condition={commonMsg && commonMsg.length > 0 && active}>
                {commonMsg.map(item => (
                  <p
                    className={`${isPWA ? 'fs-13' : 'fs-caption-2'} ${
                      status ? 'color-8a' : 'c-grey-30'
                    } pt-1`}
                  >
                    {item}
                  </p>
                ))}
              </If>
              <If condition={docs && docs.length > 0}>
                <p
                  className={`${isPWA ? 'fs-13' : 'fs-caption-2'} c-secondary-500 pt-2`}
                  onClick={e => openDoc(e, docs)}
                >
                  View documents needed
                </p>
              </If>
            </div>
          </div>
        </div>
      </li>
    </React.Fragment>
  )
}
export default RefundTrackerSteps
